<template>
  <div class="reverse grid-column-full px1 pt1 grid menu">
    <div class="grid-column-start-1 grid-column-end-3 grid-column-end-2_sm flex justify-content-space-between justify-content-start_sm">
      <lw-switch
        :label="'Role breakdown'"
        v-model="estimate.showRoleBreakdown"
        :value="estimate.showRoleBreakdown"
        @input="estimateSettings" />
      <lw-switch
        :label="'Team breakdown'"
        v-model="estimate.showTeamBreakdown"
        :value="estimate.showTeamBreakdown"
        @input="estimateSettings" />
      <lw-switch
        :label="'Red flags'"
        v-model="estimate.showRedFlags"
        :value="estimate.showRedFlags"
        @input="estimateSettings" />
    </div>
    <div class="buffer">
      <lw-text-input
        v-validate="'required|numeric'"
        :name="'project-management'"
        :id="'project-management'"
        :label="'Project buffer (%)'"
        :tip="'Create some buffer for your overages (e.g., 10% for contingencies or 15-25% for project and relationship management). You can also add markups here. This amount gets added to the total project budget.'"
        :class="['inline-block pm left', settings.projectManagement < 0 ? 'error' : '']"
        :type="'number'"
        :align="'right'"
        :size="'small'"
        v-model.number="settings.projectManagement"
        :error="errors.first('project-management')"
        @input="estimateSettings"
      />
    </div>
    <div
      v-if="estimate.rateValue"
      class="align-right rate flex flex-column justify-content-flex-end align-items-flex-end">
      <span class="price inline-block font-size-7 extra-condensed">{{ estimate.rateValue | currency }}</span><span class="font-size-2 block">/{{ rates[estimate.rateType].label | lowercase }}</span>
    </div>

  </div>
</template>

<script>
import TextInput from '../livewires/TextInput'
import ButtonGroup from '../livewires/ButtonGroup'
import Switch from '../livewires/Switch'

export default {
  components: {
    lwTextInput: TextInput,
    lwButtonGroup: ButtonGroup,
    lwSwitch: Switch
  },
  props: {
    page: {
      type: String,
      default: ''
    }
  },
  computed: {
    estimate () {
      return this.$store.getters.estimate(this.page)
    },
    settings () {
      return this.$store.getters.estimateSettings(this.page)
    },
    rates () {
      return this.$store.getters.rateUnits(this.estimate.rateCard)
    }
  },
  methods: {
    estimateSettings () {
      this.$store.dispatch('saveState', false)
      let payload = { ...this.estimate }
      payload.id = this.page
      payload.showRedFlags = this.estimate.showRedFlags
      payload.showTeamBreakdown = this.estimate.showTeamBreakdown
      payload.showRoleBreakdown = this.estimate.showRoleBreakdown
      payload.projectManagement = (this.settings.projectManagement / 100) + 1
      this.$store.dispatch('estimateSettings', payload)
    }
  }
}
</script>

<style scoped>
.menu {
  grid-template-columns: 3fr 2fr;
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
}
.pm {
  max-width: 7em;
}
.buffer,
.rate {
  margin-bottom: calc(var(--line) * 0.5);
}
.button-group {
  margin-bottom: calc(var(--line) * 0.5);
}
@media screen and (min-width: 48em) {
  .pm {
    max-width: 11em;
  }
  .buffer {
    padding-top: 0.25em;
  }
  .menu {
    grid-template-columns: 3fr 1fr 1fr;
  }
}
</style>
